export default __webpack_public_path__ + "static/media/6.0e4066b1.png";